module.exports = __webpack_public_path__ + "media/svg/selection-points-d51b650b.svg";